import { Component, ChangeDetectionStrategy } from '@angular/core';
import {StateService} from '@uirouter/angular';

@Component({
  selector: 'calculation-navigation',
  templateUrl: './calculation-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CalculationNavigationComponent {
  public state: StateService;

  constructor(private stateService: StateService) {
    this.state = stateService;
  }
}
